module.exports = __webpack_public_path__ + "static/1-4cfc446ae76ba5f91cad702193e9b3cf.png";